/**
 * Verrou de scroll de la page hôte — appelé quand le widget ouvre un calque
 * plein écran (overlay funnel) ou un drawer/bottom-sheet. Sans lui, la page
 * derrière continue de défiler (effet « modale qui ne capture pas »).
 *
 * Refcompté : plusieurs calques peuvent être ouverts simultanément ; on ne
 * déverrouille qu'au dernier fermé. SSR-safe (no-op hors navigateur). On
 * verrouille html + body (selon le navigateur, l'un ou l'autre porte le scroll)
 * et on compense la largeur de la scrollbar desktop pour éviter un saut de mise
 * en page. Les valeurs initiales sont restaurées telles quelles (on ne casse
 * pas un éventuel style inline de la page hôte).
 */
let count = 0
let prevHtmlOverflow = ''
let prevBodyOverflow = ''
let prevBodyPaddingRight = ''

export function lockScroll(): void {
  if (typeof document === 'undefined') return
  count += 1
  if (count > 1) return

  const html = document.documentElement
  const body = document.body
  const scrollbar = window.innerWidth - html.clientWidth

  prevHtmlOverflow = html.style.overflow
  prevBodyOverflow = body.style.overflow
  prevBodyPaddingRight = body.style.paddingRight

  html.style.overflow = 'hidden'
  body.style.overflow = 'hidden'
  if (scrollbar > 0) body.style.paddingRight = `${scrollbar}px`
}

export function unlockScroll(): void {
  if (typeof document === 'undefined') return
  count = Math.max(0, count - 1)
  if (count > 0) return

  document.documentElement.style.overflow = prevHtmlOverflow
  document.body.style.overflow = prevBodyOverflow
  document.body.style.paddingRight = prevBodyPaddingRight
}
